var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductHunt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1101 24.6102C19.8611 24.6102 25.334 19.1374 25.334 12.3863C25.334 5.6353 19.8611 0.162476 13.1101 0.162476C6.35906 0.162476 0.88623 5.6353 0.88623 12.3863C0.88623 19.1374 6.35906 24.6102 13.1101 24.6102ZM11.2118 12.7459L14.6345 12.7458C15.6353 12.7458 16.4465 11.9249 16.4465 10.9123C16.4465 9.89961 15.6353 9.07878 14.6345 9.07878H11.2118V12.7459ZM8.79583 6.63391H14.6345C16.9696 6.63391 18.8625 8.54939 18.8625 10.9123C18.8625 13.2751 16.9696 15.1907 14.6345 15.1907H11.2118V18.8578H8.79583V6.63391Z",
    fill: "#FF6153"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductHunt);
export default __webpack_public_path__ + "static/media/ProductHunt.db47268eff1e65a23f77dd1a547b2a86.svg";
export { ForwardRef as ReactComponent };